export default async script => { // script[type="addressLookup"]
    'use strict';

    if (!google.maps) {
        console.warn('addressLookup -> google.maps is missing');
        return;
    }

    const geocoder = new google.maps.Geocoder();

    const dataset = script.dataset;

    if (!dataset || !dataset.containerid || !dataset.select
        || !dataset.tokenheader || !dataset.tokenrequest || !dataset.distanceapi) {
        console.warn('addressLookup -> dataset.containerid, dataset.select, dataset.tokenHeader, dataset.tokenRequest, and dataset.distanceApi are required');
        return;
    }

    const container = document.getElementById(dataset.containerid);

    if (!container) {
        console.warn(`addressLookup -> The id: ${dataset.containerid} is invalid`);
        return;
    }

    const select = document.getElementById(dataset.select);

    if (!select) {
        console.warn(`addressLookup -> The id: ${dataset.select} is invalid`);
        return;
    }

    const autocomplete = new google.maps.places.Autocomplete(container);

    let timer;

    const getDealers = (function () {

        function fillDealerList(dealers) {
            const ulDealers = document.getElementById("listDealers");
            ulDealers.innerHTML = '';
            //select.innerHTML = '';

            //const firstOption = document.createElement('option');
            //firstOption.value = '';
            //firstOption.setAttribute('disabled', 'disabled');
            //firstOption.innerHTML = '-- select a dealer --';            
            //select.options.add(firstOption);
            //firstOption.selected = 'selected';

            for (let i = 0, l = dealers.length; i < l && i < 10; i++) {

                const dealerOption = document.createElement('option');
                dealerOption.value = dealers[i].id;
                dealerOption.innerHTML = dealers[i].name;

                const addressOption = document.createElement('option');
                addressOption.value = dealers[i].id;
                addressOption.setAttribute('disabled', 'disabled');
                addressOption.style.backgroundColor = '#eeeeee';
                addressOption.innerHTML = `&nbsp;&nbsp;&nbsp;${dealers[i].city}, ${dealers[i].province}`;

                //select.options.add(dealerOption);
                //select.options.add(addressOption);

                const liDealer = document.createElement('li');
                liDealer.value = dealers[i].id;
                liDealer.addEventListener('click', () => selectDealer(dealers[i]));

                const labelName = document.createElement('label');
                labelName.classList.add('name');
                labelName.innerHTML = dealers[i].name.toUpperCase();
                //labelName.addEventListener('click', selectDealer);

                const labelAddress = document.createElement('label');
                labelAddress.classList.add('address');
                labelAddress.innerHTML = `&nbsp;&nbsp;&nbsp;${dealers[i].city.toUpperCase()}, ${dealers[i].province.toUpperCase()}`;

                const labelDistance = document.createElement('label');
                labelDistance.classList.add('distance');
                labelDistance.innerHTML = `&nbsp;&nbsp;&nbsp;${dealers[i].distance} Miles Away`;

                liDealer.appendChild(labelName);
                liDealer.appendChild(labelAddress);
                liDealer.appendChild(labelDistance);
                ulDealers.appendChild(liDealer);

            }

            select.classList.remove('bg-processing');
            select.disabled = false;
        }

        function selectDealer(dealer) {
            //console.log('here');
            //console.log(dealer);
            document.getElementById('dealerSelected').value = dealer.id;
            //console.log(document.getElementById('dealerSelected').value);
            document.getElementById('selectDealer').innerHTML = dealer.name.toUpperCase();
            document.getElementById('selectDealer').classList.remove('expandedp')
        }

        function locateCurrentPosition() {
        }

        function onGeoLookupReturn(results, status) {
            if (status === google.maps.GeocoderStatus.OK) {
                const latitude = results[0].geometry.location.lat();
                const longitude = results[0].geometry.location.lng();
                const url = `${dataset.distanceapi}?latitude=${latitude}&longitude=${longitude}&radius=5000&decimalPlaces=1&measureUnit=Miles`;

                $.ajax({
                    method: 'GET',
                    url: url,
                    beforeSend: (xhr) => {
                        xhr.setRequestHeader(dataset.tokenheader, dataset.tokenrequest)
                    },
                    contentType: "application/json;charset=utf-8",
                    success: (response) => {
                        fillDealerList(response);
                    },
                    error: (e) => {
                        console.error(e);
                        throwError();
                    }
                });
            } else {
                throwError();
            }
        }

        function throwError() {
            select.classList.add('sel-disabled');
            select.classList.remove('bg-processing');
            container.value = '[ERROR]';
        }

        return (coordinates) => {
            select.classList.remove('sel-disabled');
            select.classList.add('bg-processing');

            if (coordinates) {
                onGeoLookupReturn(coordinates, google.maps.GeocoderStatus.OK);
            } else {
                const address = container.value;
                geocoder.geocode({ 'address': address }, onGeoLookupReturn);
            }
        }
    })();

    // Action(s)
    google.maps.event.addListener(autocomplete, 'place_changed', getDealers);

    navigator.geolocation.getCurrentPosition(
        position => {
            if (position && position.coords && position.coords.latitude && position.coords.longitude) {
                const results = [{
                    geometry: {
                        location: {
                            lat: () => { return position.coords.latitude; },
                            lng: () => { return position.coords.longitude; }
                        }
                    }
                }];
                getDealers(results);
            }
        },
        error => { },
        {
            enableHighAccuracy: true,
            timeout: 10000,
            maximumAge: 1000
        }
    );

    select.disabled = 'disabled';
    select.classList.add('sel-disabled');
};
